import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getDay',
  standalone: true,
})
export class GetDayPipe implements PipeTransform {
  transform(dayIndex: number): string {
    const daysOfWeek = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
    return daysOfWeek[dayIndex] ?? 'Jour inconnu';
  }
}
